import { put, call, takeEvery } from 'redux-saga/effects';

import { REQUEST_GET_UPDATE_HISTORY_DATA_FOR_SYSTEM } from '../types/updateHistoryTypes';
import {
  setUpdateHistoryDataDictionary,
  setIsGetUpdateHistoryError,
} from '../../../reducers/updateHistorySlice';

export default function* updateHistorySagaForSystem(api) {
  yield takeEvery(
    REQUEST_GET_UPDATE_HISTORY_DATA_FOR_SYSTEM,
    function* updateHistoryWorker(action) {
      yield* handleUpdateHistory(action, api);
    },
  );
}

function* handleUpdateHistory(action, api) {
  const { farmId, startDate, endDate, systemId } = action.payload;
  yield call(
    getUpdateHistoryDataForSystem,
    api,
    farmId,
    startDate,
    endDate,
    systemId,
  );
}

/** Create request to get update history data for specific farm id, start date and end date
 * @param {string} farmId - farm id
 * @param {Date} startDate - Start date of the data range
 * @param {Date} endDate - Start date of the data range
 * @param {string} systemId - system Id
 */
function* getUpdateHistoryDataForSystem(
  api,
  farmId,
  startDate,
  endDate,
  systemId,
) {
  try {
    const updateHistoryData = yield call(
      api.getUpdateHistoryForFarm,
      farmId,
      startDate,
      endDate,
      systemId,
    );
    yield put(
      setUpdateHistoryDataDictionary({
        updateHistoryDataForSystem: updateHistoryData.data,
        systemId,
      }),
    );
  } catch (error) {
    yield put(setIsGetUpdateHistoryError({ systemId, errorMessage: error }));
  }
}
